import getUserSkypeOptions from './getUserSkypeOptions';
import SkypeOptionViewState from '../data/store/schema/SkypeOptionViewState';
import getSkypeOptions from '../data/store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { SkypeNotificationOptions } from 'owa-outlook-service-options';
import { select } from 'satcheljs/lib/legacy';

export interface IsSkypeOptionDirtyState {
    optionState: SkypeOptionViewState;
    userOptions: SkypeNotificationOptions;
}

export default select<IsSkypeOptionDirtyState>({
    optionState: () => getSkypeOptions(),
    userOptions: () => getUserSkypeOptions(),
})(function isSkypeOptionDirty(state?: IsSkypeOptionDirtyState) {
    let { optionState, userOptions } = state;

    return (
        isOptionDirty(optionState.imNotification, userOptions.skypeMessageNotification as number) ||
        isOptionDirty(optionState.callNotification, userOptions.skypeCallingNotification as number)
    );
});

function isOptionDirty(optionState: number, userOption: number): boolean {
    return getFallbackValueIfNull(optionState, userOption) !== userOption;
}
